<template>
  <div>
    <v-select
      :items="lanstyrelseOptions"
      v-model="lanstyrelse"
      label="Länsstyrelse"
      dense
      outlined
      clearable
      hide-details
    />
  </div>
</template>

<script>
import { lanstyrelseOptions } from '@/assets/data/options'

export default {
  name: 'FilterLansstyrelse',
  props: {
    article_name: { type: String },
  },
  data() {
    return {
      lanstyrelseOptions,
    }
  },
  computed: {
    lanstyrelse: {
      get() {
        if (!this.article_name) return null
        return this.article_name.trim()
      },
      set(value) {
        this.$emit('change', { key: 'article_name', value })
      },
    },
  },
}
</script>

<style lang="less" scoped></style>
